<script>
    export let text = 'Join Governance Council';
    export let height = '9.346vw';
    export let width = '60.748vw';
    export let bgcolor = 'black';
    export let txtcolor = 'white';
    export let border = 'white';
    export let state = 'temp';
    import MobilePopup from './mobilePop.svelte';
    export let textPadding = '0.8vw';
    let edit = false;
    export let popup = 'true';
</script>

<div class="main" 
role="presentation"
on:click={() => {
    edit = true;
}}>
    <div
        class="btn"
        style="height:{height}; width:{width}; background-color:{bgcolor}; border:0.234vw solid {border};"
    >
        <div class="txt" style="color:{txtcolor}; padding-top: {textPadding};">{text}</div>
    </div>
</div>
{#if (edit) && (popup == 'true')}
    <MobilePopup
    JoinAs = {state}
        on:click={() => {
            edit = false;
        }}
    />
{/if}

<style>
    .main{
        width: fit-content;
        margin: auto;
    }
    .txt {
        font-family: "Orbitron";
        font-size: 1.869vw;
        font-weight: 700;
        letter-spacing: 0.02em;
        text-align: center;
        font-size: 2.804vw;
        font-weight: 700;
        line-height: 7.5vw;
        /* padding-top: 0.8vw; */
    }
</style>
